import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import {
  SAVE_FIELD_RINGS,
  SAVE_FIELD_TABLETOP,
  SAVE_FIELDS
} from "@/store/mutation-types";

export default {
  actions: {
    searchFields: ({ state }, payload) => {
      return state.fields.filter(f => f.name.includes(payload.query));
    },
    saveFieldRings: ({ commit }, payload) => {
      commit(SAVE_FIELD_RINGS, { data: payload });
    },
    saveFieldTableTop: ({ commit }, payload) => {
      commit(SAVE_FIELD_TABLETOP, { data: payload });
    },
    changeFieldName: async (_, payload) => {
      return ApiRequest.explorePost(
        "change_attribute",
        {
          layerid: payload.field,
          attribute: "name",
          value: payload.name
        },
        GetHeaders.dataHeaders()
      ).then(res => {
        return res;
      });
    },
    changeFieldNamesAi: async (_, payload) => {
      return ApiRequest.explorePost(
        "update_field_names",
        payload,
        GetHeaders.dataHeaders()
      ).then(res => {
        return res;
      });
    },
    changeFieldNameAi: async (_, payload) => {
      return ApiRequest.explorePost(
        "update_field_name",
        payload,
        GetHeaders.dataHeaders()
      ).then(res => {
        return res;
      });
    },
    resetFieldName: async (_, payload) => {
      return ApiRequest.explorePost(
        "change_attribute",
        {
          layerid: payload.field,
          attribute: "name",
          value: null
        },
        GetHeaders.dataHeaders()
      ).then(res => {
        return res;
      });
    },
    fieldNamesAiStatus: async (_, payload) => {
      return ApiRequest.exploreGet(
        `update_field_names_status/${payload}`,
        GetHeaders.dataHeaders()
      ).then(res => {
        return res.data;
      });
    }
  },
  getters: {
    fieldBookmarks: (state, getters, rootState) =>
      rootState.setting.dataSettings.fields.fieldBookmarks,
    fieldComments: (state, getters, rootState) =>
      rootState.setting.dataSettings.fields.fieldComments,
    fieldsLookup: state => payload => {
      return state.fields.find(field => field._id === payload.id);
    }
  },
  mutations: {
    [SAVE_FIELDS](state, payload) {
      state.fields = payload.fields;
    },
    [SAVE_FIELD_RINGS](state, payload) {
      state.fieldRings = payload.data;
    },
    [SAVE_FIELD_TABLETOP](state, payload) {
      state.fieldTableTop = payload.data;
    }
  },
  state: {
    fieldRings: null,
    fieldTableTop: null,
    fields: []
  }
};
